import React from 'react';
import DriverPaymentDetails from '../driver/DriverPaymentDetails';
import { Link } from 'react-router-dom';
import { paymentLabel } from '../../utils/wallet';
export default function PaymentDetails({ order, driver = false }) {
  if(driver)return <DriverPaymentDetails order={order}/>;
  return <div className="my-2"><span>{paymentLabel(order?.paymentMethod)}</span> <small className="text-muted">Payment status: {order?.paymentStatus || 'Unavailable'}</small>
    {!driver && (order?.id || order?.deliveryId || order?.orderId) && <div><Link to={`/dashboard/payments/${encodeURIComponent(order.id || order.deliveryId || order.orderId)}`}>Payment and refunds</Link>{['PENDING','CONFIRMED','ASSIGNED'].includes(order.status)&&<div><Link className="text-danger" to={`/dashboard/payments/${encodeURIComponent(order.id || order.deliveryId || order.orderId)}`}>Cancel order</Link></div>}</div>}
  </div>;
}
